export enum RoutePath {
  Client = '/v2/my-area',
  ClientAddresses = '/v2/my-area/addresses',
  ClientPkg = '/v2/my-area/packages',
  ClientPkgUnite = '/v2/my-area/packages/unite',
  ClientPkgReturn = '/v2/my-area/packages/return',
  ClientProfile = '/v2/my-area/profile',
  Login = '/v2/login',
  ForgotPassword = '/v2/forgot-password',
  ReceiptUpload = '/v2/receipt-upload',
  PaymentShipping = '/v2/payment/shipping',
  PaymentSummary = '/v2/payment/summary',
  PaymentProcess = '/v2/payment/process',
}
